import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-72">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-73"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-74">
        <div className="max-w-4xl mx-auto text-center" data-id="element-75">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-transparent bg-clip-text bg-gradient-to-b from-white to-steel-300" data-id="element-76">
            Recupera tu Agudeza Mental: El Protocolo de 10 Minutos para la Mujer
            50+
          </h1>

          <h2 className="text-xl md:text-2xl text-amber-400/90 font-medium mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-77">
            Detén la neblina mental y el miedo a los olvidos antes de que toques
            la almohada.
          </h2>

          <div className="relative max-w-2xl mx-auto mb-12" data-id="element-78">
            <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/20 to-navy-700/20 rounded-2xl blur-lg" data-id="element-79"></div>
            <img src="https://cdn.magicpatterns.com/uploads/tDNc8BDctTFwjhnqsn9a5u/imagen_memoria_de_acero.png" alt="Memoria de Acero - Protocolo de Noche en tablet" className="relative rounded-2xl shadow-2xl border border-steel-400/10 w-full object-cover" data-id="element-80" />
          </div>

          <CTAButton data-id="element-81" />
        </div>
      </div>
    </section>;
}